<div mat-dialog-title>
  <div class="d-flex justify-content-between">
      Add or Edit - Menu
      <i class="fa fa-times-circle pull-right" (click)="closeDialog()" aria-hidden="true"></i>
  </div>
</div>
<div mat-dialog-content>
  <div class="row eip-form-controls m-0 eip-mt-15 space">
      <div class="col-xl-6 col-lg-6 col-md-8 col-sm-12 col-xs-24">
          <mat-form-field style="width: 100%;">
              <mat-label>Menu Name</mat-label>
              <input matInput required [(ngModel)]="data.displayName">
          </mat-form-field>
      </div>
      <div class="col-xl-6 col-lg-6 col-md-8 col-sm-12 col-xs-24">
          <mat-form-field style="width: 100%;">
              <mat-label>Menu Icon</mat-label>
              <input matInput required [(ngModel)]="data.icon">
          </mat-form-field>
      </div>
  </div>
  <div class="row eip-form-controls m-0 eip-mt-15 space">
      <div class="col-xl-6 col-lg-6 col-md-8 col-sm-12 col-xs-24">
          <mat-form-field style="width: 100%;">
              <mat-label>Menu URI</mat-label>
              <input matInput required [(ngModel)]="data.routeUrl">
          </mat-form-field>
      </div>
      <div class="col-xl-6 col-lg-6 col-md-8 col-sm-12 col-xs-24">
          <mat-form-field style="width: 100%;">
              <mat-label>Menu Order</mat-label>
              <input matInput required type="number" [(ngModel)]="data.menuOrder">
          </mat-form-field>
      </div>
      <div class="col-xl-6 col-lg-6 col-md-8 col-sm-24 col-xs-24">
          <mat-form-field style="width: 100%;">
              <mat-label>Help URI</mat-label>
              <input matInput [(ngModel)]="data.help_url">
          </mat-form-field>
      </div>
  </div>
  <div class="row eip-form-controls m-0 eip-mt-15 space">
      <div class="col-xl-4 col-lg-4 col-md-5 col-sm-7 col-xs-13">
          <div class="view-info eip-mb-20">
              <mat-label>Active Status:</mat-label>
              <div>
                  <kendo-switch [onLabel]="'Yes'" [offLabel]="'No'" [(ngModel)]="data.isActive" [disabled]="false" [checked]="true"></kendo-switch>
              </div>
          </div>
      </div>
      <div class="col-xl-4 col-lg-4 col-md-5 col-sm-7 col-xs-13">
          <div class="view-info eip-mb-20">
              <mat-label>Admin Menu:</mat-label>
              <div>
                  <kendo-switch [onLabel]="'Yes'" [offLabel]="'No'" [(ngModel)]="data.isAdminMenu" [disabled]="false" [checked]="true"></kendo-switch>
              </div>
          </div>
      </div>
      <div class="col-xl-4 col-lg-4 col-md-5 col-sm-7 col-xs-13 ">
          <div class="view-info eip-mb-20">
              <mat-label>Project Code :</mat-label>
              <div>
                  <kendo-switch [onLabel]="'Yes'" [offLabel]="'No'" [(ngModel)]="data.isProjectCodeRequired" [disabled]="false" [checked]="true"></kendo-switch>
              </div>
          </div>
      </div>
  </div>
  <div mat-dialog-actions>
      <div class="row justify-content-end flex-grow-1">
          <button class="btn btn-primary" (click)="postData()"><i class="fa fa-save" aria-hidden="true" id="btnCopy"></i>&nbsp;&nbsp;Save</button>
      </div>
  </div>
</div>